export default class MemberAgeGroups {
    static modelName = 'MemberAgeGroups'; 
    id: number
    activ: boolean = true
    groupName: string
    groupDescription: string
    groupAgeFrom: number
    groupAgeTo: number
    isJahrgang: boolean
    [key: string]: any;
}